import O1HD from "../../../../../engines/gameEngine";
import LotterySuperGGLV2Prefab from "./LotterySuperGGLV2Prefab";
import normalMode from "../../../normalMode";

const {ccclass, property} = cc._decorator;

/**
 *
 */
@ccclass
export default class SuperGGLItemPrefab extends cc.Component {

    @property({type:cc.Label,displayName:"编号"})
    lbNum : cc.Label = null;
    @property({type:cc.Node})
    bottomLightNode : cc.Node = null;
    @property({type:cc.Sprite})
    prizeIconSpirit : cc.Sprite = null;
    @property({type:cc.SpriteFrame})
    prizeSpiritFrame : cc.SpriteFrame[] = [];
    @property(cc.Node)
    maskNode : cc.Node = null;
    @property(cc.Node)
    judge1Node : cc.Node = null;

    @property
    mIndex : number = 0;
    @property( LotterySuperGGLV2Prefab )
    mParentScript : LotterySuperGGLV2Prefab = null;

    private flag1 : boolean = false;
    private mPrize : number ;

    //可以刮刮乐
    private canShaveFlag : boolean = false;

    onLoad () {
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchstart",this.touchStart.bind(this) );
        this.node.getChildByName("bg").getChildByName("touchNode").on("touchmove",this.touchMove.bind(this) );
        //
        O1HD.on("SuperGGLItemPrefab.setPrize" , this.setPrize , this );
        //设置光效
        O1HD.on("SuperGGLItemPrefab.setLight" , this.setLight , this );
        //重置
        O1HD.on("SuperGGLItemPrefab.reset" , this.reset , this );
    }

    start () {
        this.lbNum.string = `${this.mIndex}`;
    }

    /**
     * 重置
     */
    reset(){
        this.bottomLightNode.active = false;
        this.maskNode.active = true;
        this.mPrize = null;
        this.canShaveFlag = false;
        this.hasOpenFlag = false;
        this.flag1 = false;
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.clear();
    }

    /**
     * 设置奖项
     * @param prize
     */
    setPrize( index : number , prize : number ){
        if ( this.mIndex == index ) {
            this.mPrize = prize;
            this.setIcon();
            this.maskNode.active = false;
        }
    }

    /**
     * 设置icon
     */
    setIcon(){
        switch ( this.mPrize ) {
            case 0:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[0];
                break;
            case 5:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[1];
                break;
            case 200:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[2];
                break;
            case 8888:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[3];
                break;
            case 50000:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[4];
                break;
            case 1000000:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[5];
                break;
            case 5000000:
                this.prizeIconSpirit.spriteFrame = this.prizeSpiritFrame[6];
                break;
        }
    }

    touchStart(e:cc.Event.EventTouch){
        if ( this.canShaveFlag == false ){
            return;
        }
        if ( !this.mPrize && this.mPrize != 0 ) {
            this.mPrize = this.mParentScript.getPrize();
            this.setIcon();
        }
    }
    touchMove(e:cc.Event.EventTouch){
        if ( this.canShaveFlag == false ){
            return;
        }

        let distance = Math.abs( Math.floor( e.getLocation().sub( e.getPreviousLocation() ).mag() ) );
        if ( distance > 5 ) {
            //补点操作
            for ( let num = 0 ; num < distance ; num += 3 ) {
                let subLocation : cc.Vec2 = e.getLocation().sub( e.getPreviousLocation() );
                let actualLocation = e.getPreviousLocation().add( subLocation.div( distance ).mul( num ) );
                this._addCircle( this.maskNode.convertToNodeSpaceAR( actualLocation ) );
                this.checkJudgeNode( actualLocation );
            }
        }
        this._addCircle( this.maskNode.convertToNodeSpaceAR( e.getLocation() ) );
        this.checkJudgeNode( e.getLocation() );
    }

    //效果渲染
    maskGraphicsPos1:cc.Vec2[] = [];
    _addCircle(pos:cc.Vec2){
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.circle (pos.x,pos.y, 20 )
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.fill();
        // @ts-ignore
        this.maskNode.getComponent(cc.Mask)._graphics.stroke();
        this.maskGraphicsPos1.push(pos);
    }

    /**
     * 检查是否过了 判断点
     * @param pos
     * @private
     */
    checkJudgeNode ( pos : cc.Vec2 ) {
        if ( this.judge1Node.getBoundingBoxToWorld().contains( pos ) ) {
            this.flag1 = true;
            this._checkFinish();
            return ;
        }
    }

    private hasOpenFlag : boolean = false;
    private _checkFinish(){
        if ( this.flag1 && !this.hasOpenFlag ) {
            this.hasOpenFlag = true;
            // 开奖
            this.mParentScript.openPrize( this.mPrize , this.node );
        }
    }

    /**
     * 点亮
     * @param index
     */
    setLight( index : number , canShoveFlag : boolean ){
        if ( this.mIndex == index ) {
            O1HD.getManagers().soundMgr.playSound("gglStep").then();
            let seconds : number = 0.3;
            this.canShaveFlag = canShoveFlag;
            this.bottomLightNode.opacity = 50;
            this.bottomLightNode.active = true;
            if ( this.maskNode.active == false && canShoveFlag == true ) {
                //中头彩
                this.mParentScript.openPrize( this.mPrize , this.node );
            }
            cc.tween( this.bottomLightNode )
                .to( seconds,{opacity : 255 })
                .call(()=>{
                    if ( this.canShaveFlag == false ) {
                        cc.tween( this.bottomLightNode )
                            .to(seconds,{ opacity : 50 })
                            .call(()=>{
                                this.bottomLightNode.active = false;
                            }).start();
                    }
                })
                .start();
        }
    }
}
